import { FC } from 'react'
import { useRecoilValue } from 'recoil'
import styled from 'styled-components'
import { Layout } from '../../components/Layout'
import { Footer } from '../../components/home/Footer'
import { MessageSection } from '../../components/home/MessageSection'
import { StepType, stepState } from '../../states/messageState'

export const Inquiry: FC = () => {
  const currentStep = useRecoilValue(stepState)

  return (
    <Layout>
      <StyledSection currentStep={currentStep}>
        <MessageSection />
      </StyledSection>
      <Footer />
    </Layout>
  )
}

const StyledSection = styled.section<{ currentStep: StepType }>`
  margin-top: 27vh;
  margin-bottom: ${({ currentStep }) => (currentStep === 'chooseProduct' ? '210px' : '110px')};
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
`
